import React, { useState, useEffect } from 'react';
import { MiniMap } from 'reactflow';

const ResponsiveMiniMap = () => {
  // Only show minimap on screens wider than 768px (md breakpoint)
  const [showMiniMap, setShowMiniMap] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setShowMiniMap(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!showMiniMap) return null;

  return (
    <MiniMap 
      nodeStrokeColor="#666"
      nodeColor="#fff"
      nodeBorderRadius={8}
    />
  );
};

export default ResponsiveMiniMap; 